import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject } from 'vue';
import { formItemInjectionKey, FormItemInjection } from '@/core/components/forms/Form/form.shared';
import { StInputText } from './input-text.styled';
import { props as propsDefinition } from './input-text.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkInputText',
  props: propsDefinition,
  setup(__props) {


const injection = inject(formItemInjectionKey) as FormItemInjection;
const id = computed(() => injection?.id);
const error = computed(() => !!(injection?.error.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StInputText), _mergeProps({
    error: _unref(error),
    type: "text",
    id: _unref(id)
  }, _ctx.$attrs), null, 16, ["error", "id"]))
}
}

})